export enum TalkViewerFontFamilyType {
  Myeongjo = 'myeongjo',
  Gothic = 'gothic',
  Default = 'noto_sans',
}
